<rask-fieldset-toggle label="Affärsform"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-tree-selector
        class="w-100"
        placeholder="Välj affärsform"
        label="Affärsform"
        [disabled]="!virkeskopFilterSelected()"
        (change)="setAnskaffningsformFromSelector()"
        [items]="selectableAffarsformer">
    </rask-tree-selector>
</rask-fieldset-toggle>
